<template>
  <th data-column-id="_id" data-identifier="_id" data-visible="false">ID</th>
</template>

<script>
export default {
  name: 'PkHeader'
}
</script>
